import { createApp, defineComponent } from 'vue';
import axios from 'axios'; // If you use axios instead of jQuery for AJAX requests

document.addEventListener("turbo:load", function () {
  if (document.getElementById("right_navigation")) {
    const MessagesGlobalCounter = defineComponent({
      name: 'MessagesGlobalCounter',
      data() {
        return {
          unread: Number(messaging_unread_count) || 0,
          badge_seen: false
        };
      },
      created() {
        this.updateBadgeVisibility();
      },
      watch: {
        unread: 'updateBadgeVisibility'
      },
      methods: {
        updateBadgeVisibility() {
          this.badge_seen = this.unread > 0;
        },
        // we need to request counter ourselves sometimes
        requestUpdatedCount() {
          axios.get('/dialogs/global_unread_count')
            .then(response => {
              this.unread = response.data.global_unread_count;
            })
            .catch(error => {
              console.error('Error fetching unread count:', error);
            });
        }
      }
    });

    // Create and mount the Vue app. Expose it so the Faye subscription can push live unread updates.
    window.vm_messaging_counter = createApp(MessagesGlobalCounter).mount('#right_navigation');
  }
});
